module.exports = __webpack_public_path__ + "img/5th gen - 1st Anniversary (Shishi) - Forever9Nine.b4e8a928.png";